<template>
  <div>
    <div v-if="collaborator === null"></div>
    <v-dialog v-else v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="modal_title">
          <span>INFORMACIÓN DEL COLABORADOR</span>
        </v-card-title>
        <v-card-text>
          <div id="grid">
            <div class="avatar_container">
              <div class="empty_avatar_box"
                v-if="collaborator.image === undefined || collaborator.image === null || collaborator.image === ''">
                <input id="file" class="box__file" type="file" name="files[]" accept="image/jpeg, image/png, image/jpg"
                  data-multiple-caption="{count} files selected" multiple @change="handleAvatar" />
                <img class="avatar_empty" :src="require('@/assets/icons/add-contact.svg')" />
              </div>
              <div v-else class="avatar_box">
                <input id="file" class="box__file" type="file" name="files[]" accept="image/jpeg, image/png, image/jpg"
                  data-multiple-caption="{count} files selected" multiple @change="handleAvatar" />
                <img :src="collaborator.image" class="avatar" />
              </div>
              <span>Agregar foto</span>
            </div>
            <div class="grid_item_input">
              <span class="custom_input_title">Nombre</span>
              <v-text-field class="border-container input-height" hide-details solo flat dense required height="35"
                v-model="collaborator.firstName" />
              <span v-show="!flags.firstName" class="v-messages error--text custom_span_error">
                Ingresa un nombre
              </span>
            </div>
            <div class="grid_item_input">
              <span class="custom_input_title">Apellidos</span>
              <v-text-field class="border-container input-height" hide-details solo flat dense required height="35"
                v-model="collaborator.lastName" />
              <span v-show="!flags.lastName" class="v-messages error--text custom_span_error">
                Ingresa un apellido
              </span>
            </div>
            <div class="grid_item_input">
              <span class="custom_input_title">Correo electrónico</span>
              <!-- <v-text-field hide-details solo flat dense required /> -->
              <v-text-field class="border-container input-height" hide-details solo flat dense required height="35"
                v-model="collaborator.email" />
              <span v-show="!flags.email" class="v-messages error--text custom_span_error">
                Ingresa un correo válido
              </span>
            </div>
            <div class="grid_item_input">
              <span>Rol</span>
              <v-select :items="statusTypes" height="35" class="border-container input-height" v-model="statusSelected"
                dense full-width hide-details>
                <template v-slot:selection="{ item, index }">
                  <span>
                    {{ item }}
                  </span>
                </template>
              </v-select>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn primary flat @click="close" class="modal_button">Cancelar</v-btn>
          <v-btn primary flat @click="submit" class="modal_button">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createCollaboratorAdapter, editCollaboratorAdapter } from '../fabricModels';

export default {
  props: ['collaborator', 'value', 'isNewCollaborator'],
  data: () => ({
    statusSelected: 'Administrador',
    statusTypes: [
      'Administrador',
    ],
    value: false,
    flags: {
      firstName: false,
      lastName: false,
      email: false,
    },
    isImageUpdate: false,
  }),
  methods: {
    handleAvatar() {
      this.isImageUpdate = true;
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result

        this.collaborator = { ...this.collaborator, image: base64String };
      };
      reader.readAsDataURL(file);
    },
    async submit() {
      const isValidForm = Object.values(this.flags).every((flag) => flag === true)
      if (!isValidForm) {
        console.log('not ok');
        return
      }


      let parsedImg = null
      if (this.isImageUpdate) {
        parsedImg = this.collaborator.image
          .replace('data:', '')
          .replace(/^.+,/, '')
      }

      const parsedCollaborator = { ...this.collaborator, image: parsedImg }

      if (this.isNewCollaborator) {
        const ParsedCollaborator = { collaborator: { ...createCollaboratorAdapter(parsedCollaborator), role: this.statusSelected }, isNewCollaborator: this.isNewCollaborator };
        this.$emit('update', ParsedCollaborator)
      }

      if (!this.isNewCollaborator) {
        const ParsedCollaborator = { collaborator: { ...editCollaboratorAdapter(parsedCollaborator), role: this.statusSelected }, isNewCollaborator: this.isNewCollaborator };
        this.$emit('update', ParsedCollaborator)
      }


      this.close();
    },
    blobToBase64(blob) {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    async getBase64FromUrl(url) {
      const data = await fetch(url);
      const blob = await data.blob();
      return this.blobToBase64(blob)
    },
    close() {
      this.$emit("input", !this.value);
      this.isImageUpdate = false;
    }
  },
  watch: {
    'collaborator.firstName': function (newVal, oldVal) {
      if (newVal.replaceAll(' ', '') === '') {
        this.flags.firstName = false;
        return;
      }

      this.flags.firstName = true;
      return;
    },
    'collaborator.lastName': function (newVal, oldVal) {
      if (newVal.replaceAll(' ', '') === '') {
        this.flags.lastName = false;
        return;
      }

      this.flags.lastName = true;
      return;
    },
    'collaborator.email': function (newVal, oldVal) {
      const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
      const isValidEmail = emailRegex.test(this.collaborator.email);

      if (!isValidEmail) {
        this.flags.email = false;
        return;
      }

      this.flags.email = true;
    },
  },
}
</script>

<style scoped>
.custom_input_title {
  font-weight: 500;
}

.modal_title {
  text-transform: uppercase;
  font-weight: bold;
}

.modal_button {
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: capitalize;
}

#grid {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
}

.avatar_container {
  grid-column: span 2;
  display: flex;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;
}

.avatar_container span {
  margin-top: 15px;
}


.empty_avatar_box,
.avatar_box {
  position: relative;
}

.empty_avatar_box {
  padding-left: 25px;
}

.empty_avatar,
.avatar {
  height: 130px;
  width: 130px;
}

.avatar {
  border-radius: 100%;
  object-fit: cover;
}

.box__file {
  cursor: pointer;
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateX(-25px);
}

.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

.custom_span_error {
  font-weight: 400;
}

.grid_item_input {
  grid-column: span 1;
}

@media (max-width: 594px) {
  .grid_item_input {
    grid-column: span 2;
  }
}

.input-height {
  height: 45px;
}

::v-deep .v-select__selections {
  padding: 0 !important;
}
</style>
